let transferIndex = 0;

function transferIncrease() {
    transferIndex++;

    // console.log('transferIndex', transferIndex)
}

export {transferIndex, transferIncrease};



// WEBPACK FOOTER //
// ./src/utils/transfer-queue.js